import * as yup from "yup";

const couponValidatorSchema = yup.object().shape({
  query: yup.string().required("Input is required").optional(),
});

export default couponValidatorSchema;
